<template>
  <main ref="targetElement" class="together page-main">
    <section class="together-visual" data-style="show">
      <picture>
        <source media="(min-width: 750px)" srcset="~@/static/image/together/pc/visual@3x.jpg 3x">
        <source media="(max-width: 750px)" srcset="~@/static/image/together/m/visual@3x.jpg 3x">
        <img src="~@/static/image/together/pc/visual.jpg" :alt="$t('together.head')">
      </picture>
    </section>

    <section class="page-heading-wrap together-heading-wrap">
      <h3 class="page-heading">{{ $t('together.head') }}</h3>
      <div class="page-heading-desc">
        <html-view :value="$t('together.copy')" tag="p" />
      </div>
    </section>

    <tab
      ref="tab"
      :tab-list="tabList"
      class="tab-list"
      @click:tab="onClickTab"
    />

    <section>
      <div v-if="Number(categorySummary.seq) !== allCategoryNumber" class="together-title-wrap">
        <h4 class="together-title">{{ categorySummary.name }}</h4>
        <div class="together-title-sub">{{ categorySummary.explanation }}</div>
      </div>

      <div class="list list-grid together-list">
        <div
          v-for="(item, key) in writingList"
          :key="key"
          ref="list"
          class="list-box"
        >
          <a href="#" @click.prevent="linkTo(item)">
            <div class="list-thumb"><img :src="imgPath(item.writingImagePath)" alt=""></div>
            <div class="list-cont">
              <p class="list-title">{{ item.writingTitle }}</p>
              <p class="list-desc">{{ item.writingSubTitle }}</p>
              <div>
                <span class="list-category">{{
                  isKorean ?
                    item.writingCategoryKoreaName :
                    item.writingCategoryEnglishName
                }}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <loading v-if="loading" />

      <pagination
        v-if="pagination.total"
        :data="pagination"
        :more-activation="moreActivation"
        :is-mobile="isMobile"
        :minimum-size="listParams.pageSize"
        @movePage="writingMovePage"
        @more="more"
      />
    </section>
  </main>
</template>

<script>
import observer from '@/mixins/observer'
import animation from '@/mixins/animation'
import writingApi from '@/api/writing'
import isKorean from '@/mixins/isKorean'
import list from '@/mixins/list'
import observeSize from '@/mixins/observeSize'

import { mapActions, mapGetters } from 'vuex'
import listPosition from '@/mixins/listPostion'
import gtag from '@/mixins/gtag'
// import { getAverageRGB } from '@/util'

export default {
  components: {
    tab: () => import('@/components/base/Tab'),
    pagination: () => import('@/components/base/Pagination'),
    loading: () => import('@/components/base/Loading')
  },
  mixins: [isKorean, observer, animation, list, observeSize, listPosition, gtag],
  data () {
    return {
      allCategoryNumber: 0,
      defaultImgPath: require('@/static/image/default.jpg'),
      defaultTopImgPath: require('@/static/image/temp/together/visual_list.jpeg'),
      topFix: {},
      categorySeq: '',
      writingList: [],
      loading: false,
      prevRoute: null
    }
  },
  computed: {
    ...mapGetters({
      writingCategories: 'categories/get_writing_categories',
      topPosition: 'positionTop/GET_POSITION_TOP',
      savePage: 'positionTop/GET_SAVE_PATE'
    }),
    tabList () {
      const newCategory = this.writingCategories.map(v => {
        const newCategory = { ...v }
        newCategory.path = 'Writing'
        newCategory.name = this.isKorean ? newCategory.categoryKoreaName : newCategory.categoryEnglishName
        newCategory.params = { category: newCategory.categorySeq }
        newCategory.query = { page: 1 }

        return newCategory
      })

      return newCategory
    },
    categorySummary () {
      const summary = this.tabList.find(item => {
        return Number(item.categorySeq) === Number(this.$route.params.category)
      })

      if (summary) {
        return this.isKorean ? {
          seq: summary.categorySeq,
          name: summary.categoryKoreaName,
          explanation: summary.categoryKoreaExplanation
        } : {
          seq: summary.categorySeq,
          name: summary.categoryEnglishName,
          explanation: summary.categoryEnglishExplanation
        }
      }

      return {}
    }
  },
  watch: {
    isMobile (v) {
      if (!v) {
        this.writingList = this.desserts
      } else {
        // console.log('피씨에서 모바일로')
        this.getWritingMobile()
      }
    },
    '$route.params.category' (category, oldCategory) {
      this.prevRoute = null
      if (Number(category) === Number(oldCategory)) {
        return
      }

      let writingOption = {
        pageNumber: 1
      }

      if (Number(category) !== this.allCategoryNumber) {
        writingOption = {
          ...writingOption,
          categories: category
        }
      }
      this.getWriting(writingOption)
    },
    '$route.query.page' (page, oldPage) {
      this.prevRoute = null
      if (!page || this.isMobile) {
        return
      }

      const category = this.$route.params.category

      let writingOption = {
        pageNumber: page
      }

      if (Number(this.$route.params.category) !== this.allCategoryNumber) {
        writingOption = {
          ...writingOption,
          categories: category
        }
      }

      this.getWriting(writingOption)
    },
    '$route.params.locale' () {
      this.listParams.pageNumber = this.$route.query.page || 1
      this.listParams.pageSize = 12

      if (this.$route.query.page !== '1') {
        this.pagination.current = 1
        this.$router.push({
          query: {
            page: 1
          }
        }).catch(e => {
        })
      }
      this.firstGetApi()
    }
  },
  beforeMount () {
    this.listParams.pageNumber = this.$route.query.page || 1
    this.listParams.pageSize = 12
    // this.listParams.pageSize = 2
  },
  mounted () {
    this.firstGetApi()

    this.$nextTick(() => {
      this.$root.$on('router:change', this.goTabPosition)
    })
  },
  methods: {
    ...mapActions({
      localStorageChange: 'locale/localStorageChange',
      positionTopChange: 'positionTop/positionTopChange'
    }),
    linkTo (item) {
      this.positionTopChange(window.pageYOffset)
      this.$router.push({
        name: 'writingDetail',
        params: { category: this.$route.params.category, writingId: item.writingSeq, locale: this.$route.params.locale }
      })
    // :to="{ name: 'writingDetail' , params : {category: $route.params.category, writingId : item.writingSeq, locale:$route.params.locale}}"
    },
    firstGetApi () {
      let writingOption = {}
      if (String(this.$route.params.category) !== '0') {
        writingOption = { categories: this.$route.params.category }
      }

      this.categorySeq = this.$route.params.category || 0

      if (this.isMobile) {
        this.getWritingMobile()
      } else {
        this.getWriting(writingOption)
      }
    },
    async getWritingMobile () {
      this.loading = true
      let writingOption = {
        pageNumber: 1,
        pageSize: Number(this.$route.query.page || 1) * this.listParams.pageSize
      }

      if (String(this.$route.params.category) !== '0') {
        writingOption = {
          ...writingOption,
          categories: this.$route.params.category
        }
      }

      this.getListMobile(writingApi.getWriting, writingOption).then(() => {
        if (Object.keys(this.topFix).length > 0) {
          this.writingList = [
            this.topFix,
            ...this.lists
          ]
        } else {
          this.writingList = this.lists
        }
        this.loading = false
      }).then(() => {
        this.moveScrollTop()
      })
    },
    getWriting (options) {
      this.loading = true
      this.getList(writingApi.getWriting, options).then(() => {
        if (Object.keys(this.topFix).length > 0) {
          this.writingList = [
            this.topFix,
            ...this.desserts
          ]
        } else {
          this.writingList = this.desserts
        }
        this.loading = false

        this.$nextTick(() => {
          this.writingList.forEach((item, index) => {
            this.initGtag({
              element: this.$refs.list[index],
              ga: {
                name: '함께가치_게시글 리스트',
                category: this.isKorean ? item.writingCategoryKoreaName : item.writingCategoryEnglishName,
                label: item.writingTitle,
                page: '함께가치'
              }
            })
          })
        })
      }).then(() => {
        this.moveScrollTop()
      })
    },
    moveScrollTop () {
      if (this.savePage.indexOf(this.prevRoute) !== -1) {
        window.scrollTo(0, this.topPosition)
      }
    },
    writingMovePage (index) {
      this.pagination.current = index
      this.$router.push({
        query: {
          page: index
        }
      }).catch(e => {})
    },
    imgPath (value) {
      return value || this.defaultImgPath
    },
    // imageLoad () {
    //   const callback = (style) => {
    //     this.$refs.topImg.dataset.style = style
    //     this.initObserver(this.$el.querySelectorAll('section'))
    //   }
    //   getAverageRGB(this.$refs.visual, callback)
    // },
    more () {
      if (!this.moreActivation) {
        const index = this.pagination.current + 1
        this.$router.push({
          query: {
            page: index,
            size: 'mobile'
          }
        })

        let writingOption = {
          pageNumber: index
        }
        if (this.$route.params.category !== '0') {
          writingOption = {
            ...writingOption,
            categories: this.$route.params.category
          }
        }

        this.loading = true
        this.getList(writingApi.getWriting, writingOption).then(() => {
          this.writingList = [
            ...this.writingList,
            ...this.desserts
          ]
          this.loading = false
        })
      }
    },
    onClickTab (e) {
      this.setGtag({
        action: 'click',
        name: '함께가치_중간 탭',
        category: '함께가치_중간 탭',
        label: e.target.innerText,
        page: '함께가치'
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from.name
    })
  },
}
</script>
